import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Menu,
  MenuItem,
  IconButton,
  Typography,
  InputAdornment,
  TextField,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  Button,
  FormControlLabel,
  Box,
  Chip,
  Container,
  FormHelperText,
  CircularProgress,
  Divider,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  ArrowDropUp as ArrowDropUpIcon,
  AccountCircle,
  ArrowDropDown as ArrowDropDownIcon,
  ExpandMore as ExpandMoreIcon,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";
 
import "./edituser.css";
 import { axiosInstance } from "../../../services/axiosInstance";
import { endpoints } from "../../../services/endpoint";

// Mock Flag component since react-world-flags might not be available
const Flag = ({ code, className }) => (
  <span className={className} style={{ marginRight: '8px' }}>
    🏳️
  </span>
);
 
const EditUserPage = ({ users, onClose, onUpdate }) => {
  // Initialize form data with user data
  const [formData, setFormData] = useState({
    name: users?.FullName || "",
    email: users?.Email || "",
    secondaryemail: users?.SecondaryEmail || "",
    routingProfile: users?.RoutingProfile || "",
    firstname: users?.FirstName || "",
    lastname: users?.LastName || "",
    securityProfile: "",
    agentHierarchy: "",
    acwTimeout: users?.ACWTimeout || 0,
    phoneType: users?.PhoneType || "",
    countryCode: "",
    autoAcceptCalls: users?.AutoAccept || false,
    deskPhoneNumber: users?.DeskPhone || "",
    login: users?.Login || "",
    tags: users?.Tags || "",
    arn: "",
    password:users?.password,
    repeatPassword: "",
  });
 
  const [acwTimeout, setAcwTimeout] = useState(users?.ACWTimeout || 0);
  const [actionClicked, setActionClicked] = useState(null); 
  const [saveLoader, setSaveLoader] = useState(false);
  const [cancelButtonLoading, setCancelButtonLoading] = useState(false);
  const [key, setKey] = useState("");
  const [tagValue, setTagValue] = useState("");
  const [newTag, setNewTag] = useState("");
  const [showTags, setShowTags] = useState(false);
  const [tags, setTags] = useState([]);
  const [autoAcceptCalls, setAutoAcceptCalls] = useState(users?.AutoAccept || false);
  const [selectedProfiles, setSelectedProfiles] = useState(
  Array.isArray(users?.SecurityProfiles) ? users.SecurityProfiles : []
);
 
  const [phoneType, setPhoneType] = useState(users?.PhoneType || "");
  const [routingProfiles, setRoutingProfiles] = useState([]);
  const [error, setError] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const instanceAlias = localStorage.getItem("instanceName");
  const username = localStorage.getItem("username");
  const email = localStorage.getItem("Email");
  const EncryptedInstanceId=localStorage.getItem("EncryptedId");
  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");
  const fetchRoutingProfiles = async () => {
     try {
       const payload = {
         InstanceAlias:instanceAlias,
         awsAccount:customerAWSAccountId,
         region,
        ID:EncryptedInstanceId,
       };
 
       const response = await axiosInstance.post(
         endpoints.addRouting.listrouting,
         payload,
         {
           headers: {
             "Content-Type": "application/json", // Ensure content type is set correctly
           },
         }
       );
 
       console.log("Fetched Routing Profiles:", response.data);
       setRoutingProfiles(response.data); // Set the state with fetched profiles
     } catch (error) {
       if (error.response) {
         console.error("Error response data:", error.response.data);
         console.error("Error status:", error.response.status);
 
         // You can show a user-friendly message based on status code
         if (error.response.status === 403) {
           alert("You do not have permission to access this resource.");
         }
       } else {
         console.error("Error message:", error.message);
       }
     }
   };
 

   useEffect(() => {
    fetchRoutingProfiles();
  }, []);

  

  
 
  const toggleShowTags = () => setShowTags(!showTags);
 
  const handleKeyChange = (event) => {
    setKey(event.target.value);
  };
 
  const handleValueChange = (event) => {
    setTagValue(event.target.value);
  };
 
  const handleAddTag = () => {
    if (key.trim() === "" || tagValue.trim() === "") return;
    const newTagObj = { key: key.trim(), value: tagValue.trim() };
    const updatedTags = [...tags, newTagObj];
    setTags(updatedTags);
    setKey("");
    setTagValue("");
  };
 
  const handleDeleteTag = (tagToDelete) => {
    const updatedTags = tags.filter((tag) => tag.key !== tagToDelete.key);
    setTags(updatedTags);
  };
 
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
 
  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  };
 
  const validateFields = () => {
    const newErrors = {};
 
    // Validate firstname
    if (!formData.firstname) {
      newErrors.firstname = "First name is required";
    } else if (/[^a-zA-Z\s]/.test(formData.firstname)) {
      newErrors.firstname = "First name should not contain special characters";
    }
 
    // Validate lastname
    if (!formData.lastname) {
      newErrors.lastname = "Last name is required";
    } else if (/[^a-zA-Z\s]/.test(formData.lastname)) {
      newErrors.lastname = "Last name should not contain special characters";
    }
 
    // Validate login
    if (!formData.login) {
      newErrors.login = "Login is required";
    }
 
    // Validate email
    if (!formData.email) {
      newErrors.email = "Email address is required";
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Invalid email address";
    }
 
    // Validate secondary email
    if (formData.secondaryemail && !validateEmail(formData.secondaryemail)) {
      newErrors.secondaryemail = "Invalid secondary email";
    }
 
    // Validate selected profiles
    if (selectedProfiles.length === 0) {
      newErrors.selectedProfiles = "At least one security profile must be selected";
    }
 
    // Validate routing profile
    if (!formData.routingProfile) {
      newErrors.routingProfile = "Routing profile is required";
    }
 
    // Validate phoneType
    if (!phoneType) {
      newErrors.phoneType = "Phone type is required";
    }
 
    // Additional validation based on phoneType
    if (phoneType === "DESK_PHONE") {
      if (!formData.countryCode) {
        newErrors.countryCode = "Country code is required";
      }
      if (!formData.deskPhoneNumber) {
        newErrors.deskPhoneNumber = "Desk phone number is required";
      }
    }
 
    setError(newErrors);
    return Object.keys(newErrors).length === 0;
  };
   const fetchUsers = async () => {
  const payload = {
    ID: EncryptedInstanceId,
    awsAccount: customerAWSAccountId,
    region: region,
    InstanceAlias: instanceAlias,
    UserName: username,
    Email: email,
  };

  try {
    const response = await axiosInstance.post(
      endpoints.userList.listusers,
      payload
    );

    console.log("Full API Response:", response.data);

    // ✅ Extract body correctly
    const users = response.data?.body;

    if (Array.isArray(users)) {
      const extractedData = users.map((item) => ({
        Login: item.Login,
        FullName: item.FullName,
        RoutingProfile: item.RoutingProfile,
        ACWTimeout: item.ACWTimeout,
        FirstName: item.FirstName,
        LastName: item.LastName,
        Email: item.Email,
        SecondaryEmail: item.SecondaryEmail || "",
        ARN: item.ARN,
        AutoAccept: item.AutoAccept,
        DeskPhone: item.DeskPhone || "",
        PhoneType: item.PhoneType,
        SecurityProfiles: item.SecurityProfiles || [],
        Tags: item.Tags || {},
      }));

      console.log("Extracted User Data:", extractedData);
      return extractedData;
    } else {
      console.warn("Users list is not an array:", users);
      return [];
    }
  } catch (error) {
    console.error("Error fetching users:", error);
    return [];
  }
};

 const handleSave = async () => {
  if (!validateFields()) return;
setActionClicked("save");
  setSaveLoader(true);

  const {
    login,
    firstname,
    lastname,
    password,
    repeatPassword,
    secondaryemail,
    email,
    routingProfile,
    autoAcceptCalls,
    acwTimeout,
    phoneType,
    countryCode,
    deskPhoneNumber,
    tags,
  } = formData;

  const requestPayload = {
    action: "edit",
    username: login,
    accessurl: "https://sravani-connectgen.my.connect.aws",
    ID:EncryptedInstanceId,
    awsAccount: customerAWSAccountId,
    InstanceAlias: instanceAlias,
    region,
    Email:email,
    UserName:username,
    firstname,
    lastname,
   
    SecondaryEmail: secondaryemail,
    email,
    AgentRole: selectedProfiles,
    RoutingProfile: routingProfile,
    AutoAccept: autoAcceptCalls,
    Acwtime: acwTimeout,
    phone_type: phoneType,
    Tags: tags.length > 0 ? tags : undefined,
  };

  if (phoneType === "DESK_PHONE") {
    requestPayload.DeskPhoneNumber = countryCode + deskPhoneNumber;
  }

  try {
    const response = await axiosInstance.post(endpoints.addUser.newuser, requestPayload);
    console.log("User added successfully:", response.data);

    if (response.status === 200) {
      const updatedList = await fetchUsers();
      if (onUpdate) onUpdate(updatedList);
      onClose();
    }
  } catch (error) {
    console.error("Error adding user:", error);
  } finally {
    setSaveLoader(false);
    setActionClicked(null);
  }

  if (!tags?.length) {
    console.log("No tags to submit.");
  }
};

 
  const handleCountryCodeChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, countryCode: value });
    setError((prevError) => ({
      ...prevError,
      countryCode: value ? null : "Country code is required",
    }));
  };
 
  const handleDeskPhoneNumberChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, deskPhoneNumber: value });
    setError((prevError) => ({
      ...prevError,
      deskPhoneNumber: value ? null : "Phone number is required",
    }));
  };
 
  const handleSelectChange = (event) => {
    const { value } = event.target;
    setSelectedProfiles(value);
  };
 
  const handleToggle = (profile) => {
    setSelectedProfiles((prev) => {
      if (prev.includes(profile)) {
        return prev.filter((p) => p !== profile);
      } else {
        return [...prev, profile];
      }
    });
  };
 
  const handleACWTimeoutChange = (value) => {
    setAcwTimeout(value);
    setFormData((prev) => ({
      ...prev,
      acwTimeout: value,
    }));
  };
 
  const handleIncrement = () => {
    handleACWTimeoutChange(acwTimeout + 1);
  };
 
  const handleDecrement = () => {
    handleACWTimeoutChange(Math.max(0, acwTimeout - 1));
  };
 
  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setAutoAcceptCalls(isChecked);
    setFormData(prev => ({ ...prev, autoAcceptCalls: isChecked }));
  };
 
  const handleCancel = async () => {
    setActionClicked("cancel");
    setCancelButtonLoading(true);
    setTimeout(() => {
      setCancelButtonLoading(false);
      if (onClose) onClose();
    }, 1000);
  };
 
  const handleRoutingProfileChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, routingProfile: value });
    setError((prevError) => ({
      ...prevError,
      routingProfile: value ? null : "Required",
    }));
  };
 
  return (
   <div className="edituser-wrapper">
      
 
      <Container className="edituser-content-container">
<Box display="flex" flexDirection="column" alignItems="flex-start" mb={2} gap={1}>
   <IconButton
     onClick={onClose}
     size="medium"
     sx={{
       border: "1px solid #ccc",       // border color
       borderRadius: "50%",            // makes it circular
       padding: 1,                     // inner spacing
       bgcolor: "#f5f5f5",             // background color
       "&:hover": { bgcolor: "#e0e0e0" } // hover effect
     }}
   >
     <ArrowBackIcon />
   </IconButton>
  {/* Title */}
  <Typography variant="h4" className="phone-text">
    Edit User: {formData.login}
  </Typography>
</Box>
         <div className="edituser-user-form-section">
         
         
           <div className="edituser-user-form-fields">
            <TextField
             fullWidth
            label="Name"
           placeholder="Enter Name"
           className="adduser-userinfo-formfield"
            required
              value={formData.firstname}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z\s]*$/.test(value)) {
                  setFormData({ ...formData, firstname: value });
                  setError((prev) => ({ ...prev, firstname: null }));
                } else {
                  setError((prev) => ({
                    ...prev,
                    firstname: "First name should not contain special characters",
                  }));
                }
              }}
              helperText={error.firstname || ""}
              error={!!error.firstname}
              
            />
 
            <TextField
              label="Last name"
             placeholder="Enter last Name"
             className="adduser-userinfo-formfield"
              value={formData.lastname}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z\s]*$/.test(value)) {
                  setFormData({ ...formData, lastname: value });
                  setError((prev) => ({ ...prev, lastname: null }));
                } else {
                  setError((prev) => ({
                    ...prev,
                    lastname: "Last name should not contain special characters",
                  }));
                }
              }}
              helperText={error.lastname || ""}
              error={!!error.lastname}
              fullWidth
            />
 
            <TextField
              label="Login"
             className="adduser-userinfo-formfield"
              value={formData.login}
              helperText={error.login}
              error={!!error.login}
              fullWidth
              InputProps={{
                readOnly: true,
              }}
              sx={{
                ".MuiInputBase-root": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            />
 
            <TextField
              label="Email address"
            className="adduser-userinfo-formfield"
              value={formData.email}
              onChange={(e) => {
                const value = e.target.value;
                setFormData({ ...formData, email: value });
                if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                  setError((prev) => ({ ...prev, email: null }));
                } else {
                  setError((prev) => ({
                    ...prev,
                    email: "Invalid email address format",
                  }));
                }
              }}
              helperText={error.email || ""}
              error={!!error.email}
              fullWidth
            />
 
            <TextField
              label="Secondary email address"
           className="adduser-userinfo-formfield"
              value={formData.secondaryemail}
              onChange={(e) => {
                const value = e.target.value;
                setFormData({ ...formData, secondaryemail: value });
                if (value === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                  setError((prev) => ({ ...prev, secondaryemail: null }));
                } else {
                  setError((prev) => ({
                    ...prev,
                    secondaryemail: "Invalid secondary email format",
                  }));
                }
              }}
              helperText={error.secondaryemail || "Alternative email address for notifications"}
              error={!!error.secondaryemail}
              fullWidth
            />
          </div>
        </div>
 
 <div className="edituser-setting-form-section">
          <h3>Settings</h3>
         
 <div className="addusers-setting-form-fields">
           <FormControl className="edituser-securityprofile" variant="filled">
              <InputLabel>Security profile *</InputLabel>
              <Select
                multiple
                value={selectedProfiles}
                onChange={handleSelectChange}
                renderValue={(selected) => selected.join(", ")}
              className="adduser-userinfo-formfield"
              >
                {["Admin", "Agent", "CallCenterManager", "QualityAnalyst"].map((profile) => (
                  <MenuItem key={profile} value={profile}>
                    <Checkbox checked={selectedProfiles.includes(profile)} />
                    <ListItemText primary={profile} />
                  </MenuItem>
                ))}
              </Select>
              {error.selectedProfiles && (
                <FormHelperText error>{error.selectedProfiles}</FormHelperText>
              )}
            </FormControl>
 
            <TextField
              label="Routing Profile *"
             className="adduser-userinfo-formfield"
              select
              value={formData.routingProfile}
              onChange={handleRoutingProfileChange}
              helperText={error.routingProfile}
              error={!!error.routingProfile}
              fullWidth
            >
              {routingProfiles.map((profile, index) => (
                <MenuItem key={index} value={profile}>
                  {profile}
                </MenuItem>
              ))}
            </TextField>
          </div>
 
        
          <Typography className="adduserinfo-phonetext">
                             Phone
                           </Typography>
           
           <div className="edituser-phone-type-options">
            <TextField
  select
  label="Phone Type *"
  value={phoneType}
  onChange={(e) => setPhoneType(e.target.value)}
  fullWidth
  size="small"
  className="adduser-userinfo-formfield"
>
  <MenuItem value="SOFT_PHONE">SOFT PHONE</MenuItem>
  <MenuItem value="DESK_PHONE">DESK PHONE</MenuItem>
</TextField>

              {phoneType === "SOFT_PHONE" && (
                <FormControlLabel
              className="adduser-userinfo-formfield"
                  control={
                    <Checkbox
                      checked={autoAcceptCalls}
                      onChange={handleCheckboxChange}
                      color="primary"
                    />
                  }
                  label="Auto-accept calls"
                />
              )}
            </div>
            <br></br>
 
            {phoneType === "DESK_PHONE" && (
               <div className="desk-phone-options">
               <TextField
  select
  label="Country Code *"
  value={formData.countryCode}
  onChange={handleCountryCodeChange}
  fullWidth
  size="small"
  error={!!error.countryCode}
  helperText={error.countryCode}
  className="adduser-userinfo-formfield"
>
  <MenuItem value="+1">
    <Flag code="US" /> +1 (United States)
  </MenuItem>
  <MenuItem value="+1-CA">
    <Flag code="CA" /> +1 (Canada)
  </MenuItem>
  <MenuItem value="+44">
    <Flag code="GB" /> +44 (United Kingdom)
  </MenuItem>
  <MenuItem value="+52">
    <Flag code="MX" /> +52 (Mexico)
  </MenuItem>
</TextField>

                <TextField
                  label="Desk Phone Number *"
               className="adduser-userinfo-formfield"
                  value={formData.deskPhoneNumber}
                  onChange={handleDeskPhoneNumberChange}
                  
                  error={!!error.deskPhoneNumber}
                  helperText={error.deskPhoneNumber}
                  fullWidth
                />
              </div>
            )}
          
 <div className="acw-timeout-container">
  <Typography variant="body2" className="acw-label">
    After Contact Work (ACW) timeout
  </Typography>

  <TextField
   className="adduser-userinfo-formfield"
    type="number"
    label="Timeout (seconds)"
    value={acwTimeout}
    onChange={(e) => handleACWTimeoutChange(Number(e.target.value))}
    
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <div className="acw-stepper">
            <IconButton size="small" onClick={handleIncrement}>
              <ArrowDropUpIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={handleDecrement} disabled={acwTimeout <= 0}>
              <ArrowDropDownIcon fontSize="small" />
            </IconButton>
          </div>
        </InputAdornment>
      ),
    }}
  />
                <Typography className="font-medium">
                Show advanced settings
              
              <IconButton size="small">
                {showTags ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              </IconButton>
              </Typography>
                <Box
              className="flex items-center justify-between cursor-pointer p-2 hover:bg-gray-50 rounded"
              onClick={toggleShowTags}
            ></Box>
              {showTags && (
              <Box className="mt-4 p-4 bg-gray-50 rounded">
                <Typography variant="subtitle2" className="mb-3">
                  Tags
                </Typography>
               
               
 
                {tags.length > 0 && (
                  <Box className="flex flex-wrap gap-2">
                    {tags.map((tag, index) => (
                      <Chip
                        key={index}
                        label={`${tag.key}: ${tag.value}`}
                        onDelete={() => handleDeleteTag(tag)}
                        size="small"
                        variant="outlined"
                      />
                    ))}
                  </Box>
                )}
              </Box>
            )}
</div>

       </div>
 
         
 
      </Container>
 
    
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t shadow-lg p-4">
<div className="buttons-addhour" style={{ display: "flex", gap: 16 }}>
      <Button
        onClick={handleCancel}
        disabled={actionClicked === "save" || cancelButtonLoading}
        className="px-6"
      >
        {actionClicked === "cancel" ? (
          <CircularProgress size={20} />
        ) : (
          "Cancel"
        )}
      </Button>
      <Button
        variant="contained"
        onClick={handleSave}
        disabled={actionClicked === "cancel" || saveLoader}
        className="px-6"
      >
        {actionClicked === "save" ? (
          <CircularProgress size={20} style={{ color: "white" }} />
        ) : (
          "Save"
        )}
      </Button>
    </div> </div>
    </div>
  );
};
 
export default EditUserPage;